export const getResolutionErrors = (compiledScript) => compiledScript.reduce((errors, segment) => {
    switch (segment.type) {
        case 'error':
            return [
                ...errors,
                {
                    error: segment.value,
                    range: segment.range,
                },
            ];
        case 'push':
        case 'evaluation':
            return [...errors, ...getResolutionErrors(segment.value)];
        default:
            return errors;
    }
}, []);
// export const getReductionErrors = () => {};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9hdXRoL3RlbXBsYXRlcy9sYW5ndWFnZS9lcnJvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0EsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUcsQ0FDakMsY0FBOEIsRUFDVixFQUFFLENBQ3RCLGNBQWMsQ0FBQyxNQUFNLENBQXFCLENBQUMsTUFBTSxFQUFFLE9BQU8sRUFBRSxFQUFFO0lBQzVELFFBQVEsT0FBTyxDQUFDLElBQUksRUFBRTtRQUNwQixLQUFLLE9BQU87WUFDVixPQUFPO2dCQUNMLEdBQUcsTUFBTTtnQkFDVDtvQkFDRSxLQUFLLEVBQUUsT0FBTyxDQUFDLEtBQUs7b0JBQ3BCLEtBQUssRUFBRSxPQUFPLENBQUMsS0FBSztpQkFDckI7YUFDRixDQUFDO1FBQ0osS0FBSyxNQUFNLENBQUM7UUFDWixLQUFLLFlBQVk7WUFDZixPQUFPLENBQUMsR0FBRyxNQUFNLEVBQUUsR0FBRyxtQkFBbUIsQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztRQUM1RDtZQUNFLE9BQU8sTUFBTSxDQUFDO0tBQ2pCO0FBQ0gsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0FBRVQsOENBQThDIn0=